import { render, staticRenderFns } from "./ChildControlProgramForm.vue?vue&type=template&id=f047e312&scoped=true&"
import script from "./ChildControlProgramForm.vue?vue&type=script&lang=js&"
export * from "./ChildControlProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047e312",
  null
  
)

export default component.exports